import React from 'react';

function SkeletonCard() {
  return (
    <div style={styles.card}>
      <div style={styles.cardTop}>
        <div style={{ ...styles.skel, width: 48, height: 48, borderRadius: '50%' }} />
        <div style={styles.info}>
          <div style={{ ...styles.skel, width: '55%', height: 16, marginBottom: 8 }} />
          <div style={{ ...styles.skel, width: '80%', height: 12, marginBottom: 6 }} />
          <div style={{ ...styles.skel, width: '40%', height: 10 }} />
        </div>
        <div style={{ ...styles.skel, width: 72, height: 28, borderRadius: 10 }} />
      </div>
    </div>
  );
}

export default function LoadingSkeleton() {
  return (
    <div>
      {/* Fake stats bar */}
      <div style={styles.statsBar}>
        {[1,2,3,4,5].map(i => (
          <div key={i} style={styles.statCell}>
            <div style={{ ...styles.skel, width: 40, height: 24, marginBottom: 6 }} />
            <div style={{ ...styles.skel, width: 60, height: 8 }} />
          </div>
        ))}
      </div>

      {/* Fake filter bar */}
      <div style={styles.filterBar}>
        {[80, 70, 80, 70, 160].map((w, i) => (
          <div key={i} style={{ ...styles.skel, width: w, height: 30, borderRadius: 20 }} />
        ))}
      </div>

      {/* Fake job cards */}
      <div style={styles.grid}>
        {[1, 2, 3, 4, 5, 6].map(i => (
          <SkeletonCard key={i} />
        ))}
      </div>

      {/* Loading label */}
      <div style={styles.label}>
        <span style={styles.spinner} />
        Claude AI is analyzing the job market for you...
      </div>
    </div>
  );
}

const styles = {
  skel: {
    background: 'linear-gradient(90deg, #111326 25%, #1a1e35 50%, #111326 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
    borderRadius: 6,
    display: 'block',
  },
  statsBar: {
    display: 'flex',
    background: '#0d0f1c',
    border: '1px solid #1a1e35',
    borderRadius: 10,
    overflow: 'hidden',
    marginBottom: 20,
  },
  statCell: {
    flex: 1, display: 'flex', flexDirection: 'column',
    alignItems: 'center', padding: '14px 8px',
    borderRight: '1px solid #1a1e35',
  },
  filterBar: {
    display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(440px, 1fr))',
    gap: 16,
    marginBottom: 28,
  },
  card: {
    background: '#0d0f1c',
    border: '1px solid #1a1e35',
    borderRadius: 12,
    padding: '16px 18px',
  },
  cardTop: {
    display: 'flex', alignItems: 'center', gap: 14,
  },
  info: { flex: 1 },
  label: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: 10, color: '#3a4460', fontSize: 13,
  },
  spinner: {
    display: 'inline-block',
    width: 16, height: 16,
    border: '2px solid #1a1e35',
    borderTopColor: '#00e896',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
};
